const HTML_CONFIGURATION_FEATURE_TYPES = ['PDF', 'SPEECH', 'TRANSLATE'] as const;
const HTML_CONFIGURATION_PROPERTY_TYPES = ['EXCLUDE', 'INCLUDE'] as const;
const HTML_CONFIGURATION_TYPE_TYPES = ['CLASS', 'ID', 'TAG'] as const;

const RESTRICTION_TYPES = ['NONE', 'HTTP_REFERER', 'IP_ADDRESS', 'MOBILE_APP'] as const;

export { HTML_CONFIGURATION_FEATURE_TYPES, HTML_CONFIGURATION_PROPERTY_TYPES, HTML_CONFIGURATION_TYPE_TYPES, RESTRICTION_TYPES };
